//===============================================================================================================
// #3 - Import * Mixins => { Media Queries }
//===============================================================================================================
import { theming } from "./theme";

//===============================================================================================================
// #4 - Building And Exporting The Object
//===============================================================================================================
export const theme = { ...theming };